var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../../libs/dragscroll');
var auth = require('../../auth/models/session');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var equipmentClassToDisplayName = require('../../libs/equipmentClassToDisplayName');
var edit = require('../../layout/components/edit');
var modal = require('../../layout/components/modal');
var alerts = require('../../layout/components/alerts');
var modalForm = require('../../layout/components/modalForm');
var header = require('../../layout/components/header');
var modelDetail = require('../../components/modelDetail');
var modelActions = require('./modelActions');
var Point = require('../../data/models/point');
var pointForm = modalForm(Point);
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var pointTd = require('../../data/components/pointTd');
var rowActionDropdown = require('../../components/rowActionDropdown');
var networkTreeTransferModal = require('../treeTransferModal');
var tableColumns = require('./tableColumns');
var pageTitle = require('../../layout/pageTitle');
var requestState = require('../requestState');

var page = {};
var fieldsToShow = ['name', 'index', 'jsonPath', 'querySelector', 'unit', 'scale', 'writable', 'error', 'overrideActive', 'alarmStatus', 'alarmEnabled', 'alarmName'];

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function canManageNetworkPoints() {
  var user = auth.user && auth.user();
  return !!(user && (user.isSuperuser === true || Number(user.isSuperuser) === 1));
}

function pointRowActions(ctrl, children) {
  return [
    {
      label: 'Edit ' + pointForm.name,
      icon: 'ion-ios-compose',
      onclick: function () { pointForm.editDialogue(children); }
    },
    {
      label: selectedDeleteLabel(ctrl),
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { deleteSelectedPoints(ctrl, children); }
    }
  ];
}

function renderPointNameCell(ctrl, children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    canManageNetworkPoints() ? m('div.ml3.flex-none', [
      actionDropdown(pointRowActions(ctrl, children))
    ]) : null
  ]);
}

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.recordModel = vnode.attrs.recordModel
  pageTitle.set(null, { fallback: ctrl.recordModel.name });
  header.vm.activeTab(vnode.attrs.activeTab);
  ctrl.newNode = prop(false);
  ctrl.selectedPointRids = {};
  requestState.initialize(ctrl);

  ctrl.init = function () {
    return requestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        url: "/api/v1/" + ctrl.recordModel.url + '/' + m.route.param('id'),
        method: "GET"
      }).then(function(result){
        ctrl.record = result;
        pageTitle.set(ctrl.record, { fallback: ctrl.recordModel.name });
        pruneSelectedPoints(ctrl);
        ctrl.newNode(true);
      });
    });
  };

  ctrl.init();
  ctrl.childrenToShow = [];
  modal.on('closed', ctrl.init);
};

page.onremove = function(vnode) {
  modal.off('closed', this.init);
}

page.view = function () {
  var ctrl = this
  var stateView = requestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.record){
    return m('div')
  }
  var ancestors = ctrl.record.breadcrumbs.slice(0, ctrl.record.breadcrumbs.length - 1);
  var isRestResource = ctrl.record && ctrl.record['@class'] === 'RestResource';
  var networkOverviewUrl = '/' + ancestors[0]['@id'].split('/').slice(3, 4).join('/').toLowerCase();
  var networkOverviewName = ancestors[0]['@class'].replace(/([A-Z])/g, ' $1');
  var showNetworkOverview = ['BacnetServer', 'ModbusTcp', 'RestHttp', 'LontalkCnip'].indexOf(ancestors[0]['@class']) === -1;
  return m('div', [
    m("div.flex.justify-between.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.display",  [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        showNetworkOverview ? m('div.dib-ns.mr2', [
          m(m.route.Link, {href: networkOverviewUrl}, networkOverviewName),
          ' /'
        ]) : null,
        ancestors.map(function (ancestor, idx) {
          return m('div.dib-ns.mr2', [
            m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
            ' /'
          ])
        }),
        m('div.dib-ns.mr2', ctrl.record.name)
      ]),
      (function () {
        if(edit.vm.editing() && auth.user().isSuperuser == 1){
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.recordModel.name,
                icon: 'ion-ios-compose',
                onclick: () => ctrl.recordModel.editDialogue(ctrl.record, isRestResource ? { parentRecord: ancestors[0] } : undefined)
              },
              isRestResource ? {
                label: 'Export Rest Resource',
                icon: 'ion-document-text',
                onclick: () => networkTreeTransferModal.openHostExportModal(ancestors[0], [ctrl.record])
              } : null,
              {
                label: `New ${equipmentClassToDisplayName(ctrl.recordModel.name.replace(/([A-Z])/g, " $1").trim().split(" ")[0])} Points`,
                icon: 'ion-plus',
                onclick: () => pointForm.editDialogue({parent: ctrl.record['@rid']})
              }
            ].filter(Boolean)
          })
        }
      })(),
    ]),
    modelDetail(ctrl, ctrl.recordModel),
    modelActions(ctrl, ctrl.recordModel),
    m('div.mh3.mv3.bw1.pv1.tc.f3.bb', equipmentClassToDisplayName(name) + ' Points'),
    m('div', {class:"static-grid-items"}, browse(ctrl)),
  ])
};

function browse (ctrl) {
  var visiblePoints = selectablePointRecords(ctrl.childrenToShow);
  var selectedVisiblePoints = visibleSelectedPoints(ctrl);
  var allVisibleSelected = visiblePoints.length > 0 && selectedVisiblePoints.length === visiblePoints.length;
  var someVisibleSelected = selectedVisiblePoints.length > 0 && !allVisibleSelected;

  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.record.children.filter(c => !c.deleted),
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(tableColumns.withSelection(fieldsToShow.concat(['value']))),
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tc', { style: { width: '2.5rem' } }, [
                    canManageNetworkPoints() ? renderPointSelectionButton({
                      checked: allVisibleSelected,
                      mixed: someVisibleSelected,
                      disabled: visiblePoints.length === 0,
                      label: 'Select visible Points',
                      selectAll: true,
                      onclick: function () {
                        setVisiblePointsSelected(ctrl, !allVisibleSelected);
                      }
                    }) : null
                  ]),
                  fieldsToShow.map(field => {
                    return m('th.ph0.tl', field)
                  }),
                  m('th.ph0.tl', 'value')
                ])
                
              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if (!children['@rid']) {
                    return m('tr', [
                      m('td.tc.nowrap', [
                        m('div', { style: { visibility: 'hidden' } }, [
                          renderPointSelectionButton({
                            checked: false,
                            disabled: true,
                            label: 'No Data'
                          })
                        ])
                      ]),
                      fieldsToShow.map(field => {
                        return m('td.tl.nowrap',[
                          m('label',{style:{'visibility':'hidden'}}, 'No Data') 
                        ])
                      }),
                      m('td.tl.nowrap')
                    ])
                  }else{
                    let url = '/' + children['@id'].split('/').slice(3,5).join('/');
                    var selected = isPointSelected(ctrl, children);
                    return m('tr', {
                      'data-child-rid': recordRid(children)
                    }, [
                      m('td.tc.nowrap', selectedCellAttrs(selected), [
                        canManageNetworkPoints() ? renderPointSelectionButton({
                          checked: selected,
                          label: 'Select ' + (children.name || pointForm.name),
                          rid: recordRid(children),
                          onclick: function () {
                            setPointSelected(ctrl, children, !isPointSelected(ctrl, children));
                          }
                        }) : null
                      ]),
                      fieldsToShow.map(field => {
                        return m('td.tl'+(field != 'error' ? '.nowrap' : ''), selectedCellAttrs(selected), field == 'name' ? renderPointNameCell(ctrl, children, url) : children[field])
                      }),
                      // For BACnet Property pages, show link-only (no write/override modals)
                      m(pointTd, {
                        columnRecord: { in: children },
                        tdClass: '.nowrap bl-0',
                        tdStyle: selectedCellStyle(selected),
                        options: ctrl.recordModel && ctrl.recordModel.url === 'bacnetproperty' ? { disableInteractions: true } : undefined
                      })
                    ])
                  };
                })
              ])
            ])
          ])
        ])
      ])
      
    ])
  ])
};

function recordRid(record) {
  return record && record['@rid'] ? String(record['@rid']) : '';
}

function pointName(count) {
  return count === 1 ? pointForm.name : pointForm.name + 's';
}

function isPointSelected(ctrl, record) {
  var rid = recordRid(record);
  return !!(rid && ctrl.selectedPointRids && ctrl.selectedPointRids[rid]);
}

function selectablePointRecords(records) {
  return (records || []).filter(function (record) {
    return !!recordRid(record);
  });
}

function selectedPointRecords(ctrl) {
  return selectablePointRecords(ctrl.record && ctrl.record.children).filter(function (record) {
    return isPointSelected(ctrl, record);
  });
}

function visibleSelectedPoints(ctrl) {
  return selectablePointRecords(ctrl.childrenToShow).filter(function (record) {
    return isPointSelected(ctrl, record);
  });
}

function pruneSelectedPoints(ctrl) {
  var nextSelected = {};
  selectablePointRecords(ctrl.record && ctrl.record.children).forEach(function (record) {
    var rid = recordRid(record);
    if (ctrl.selectedPointRids && ctrl.selectedPointRids[rid]) {
      nextSelected[rid] = true;
    }
  });
  ctrl.selectedPointRids = nextSelected;
}

function setPointSelected(ctrl, record, selected) {
  var rid = recordRid(record);
  if (!rid) return;
  if (selected) {
    ctrl.selectedPointRids[rid] = true;
  } else {
    delete ctrl.selectedPointRids[rid];
  }
}

function setVisiblePointsSelected(ctrl, selected) {
  selectablePointRecords(ctrl.childrenToShow).forEach(function (record) {
    setPointSelected(ctrl, record, selected);
  });
}

function renderPointSelectionButton(options) {
  var checked = !!options.checked;
  var mixed = !!options.mixed;
  var disabled = !!options.disabled;
  var label = options.label;
  var className = 'ba bw1 br1 flex items-center justify-center center';
  if (options.class) className += ' ' + options.class;

  return m('button', {
    type: 'button',
    class: className,
    style: {
      width: '1.35rem',
      height: '1.35rem',
      minWidth: '1.35rem',
      padding: 0,
      borderColor: checked || mixed ? '#58abe2' : '#777',
      backgroundColor: checked || mixed ? '#58abe2' : 'transparent',
      color: checked || mixed ? '#111' : '#f4f4f4',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      lineHeight: 1
    },
    disabled: disabled,
    title: label,
    'aria-label': label,
    'aria-checked': mixed ? 'mixed' : checked ? 'true' : 'false',
    role: 'checkbox',
    'data-select-all-children': options.selectAll ? true : null,
    'data-bulk-select-rid': options.rid || null,
    onmousedown: function (evt) {
      evt.stopPropagation();
    },
    onclick: function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!disabled && typeof options.onclick === 'function') {
        options.onclick();
      }
    },
    onkeydown: function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      evt.preventDefault();
      evt.stopPropagation();
      if (!disabled && typeof options.onclick === 'function') {
        options.onclick();
      }
    }
  }, [
    checked ? m('i.f4.ion-checkmark') : mixed ? m('span.b.f4', '-') : null
  ]);
}

function selectedDeleteLabel(ctrl) {
  var count = selectedPointRecords(ctrl).length;
  if (!count) return 'Delete ' + pointForm.name;
  return 'Delete ' + count + ' selected ' + pointName(count);
}

function selectedCellStyle(selected) {
  return selected ? { backgroundColor: '#1f4358' } : undefined;
}

function selectedCellAttrs(selected) {
  var style = selectedCellStyle(selected);
  return style ? { style: style } : {};
}

function deleteErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error && typeof error.error === 'string') return error.error;
  if (error && typeof error.message === 'string') return error.message;
  return 'Delete failed';
}

function openBulkDeleteDialog(ctrl, records) {
  var recordsToDelete = records.slice();
  var count = recordsToDelete.length;
  var visibleRecords = recordsToDelete.slice(0, 10);

  var submit = function () {
    return recordsToDelete.reduce(function (promise, record) {
      return promise.then(function () {
        return pointForm.delete(record);
      });
    }, Promise.resolve())
      .then(function () {
        recordsToDelete.forEach(function (record) {
          delete ctrl.selectedPointRids[recordRid(record)];
        });
        key.unbind('enter');
        modal.vm.close();
        m.redraw();
      })
      .catch(function (error) {
        alerts.vm.add({ detail: deleteErrorMessage(error) });
        m.redraw();
        return Promise.reject(error);
      });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Delete ' + count + ' ' + pointName(count) + '?');
  modal.vm.body = function () {
    return m('div', [
      m('p.mv2', 'This will delete the selected ' + pointName(count) + '.'),
      m('ul.mv3.pl4', visibleRecords.map(function (record) {
        return m('li', record.name || recordRid(record));
      })),
      count > visibleRecords.length ? m('p.mv2', 'And ' + (count - visibleRecords.length) + ' more.') : null
    ]);
  };
  modal.vm.buttons([
    {
      label: 'Submit',
      class: 'btn-good',
      func: submit
    }
  ]);
  modal.vm.open();
}

function deleteSelectedPoints(ctrl, fallbackRecord) {
  var records = selectedPointRecords(ctrl);
  if (!records.length) {
    return pointForm.deleteDialogue(fallbackRecord);
  }
  if (records.length === 1) {
    return pointForm.deleteDialogue(records[0]);
  }
  return openBulkDeleteDialog(ctrl, records);
}

module.exports = page;
